import type { Role } from '@app/types'

export const PERMISSION = {
  // ! Реестр списков на мониторинг

  // * Просмотр реестра списков для мониторинга
  viewMonitoringListsRegistry: 'viewingMonitoringListsRegistry',
  // * Просмотр реестра списков промо мониторингов
  viewMonitoringListsPromoRegistry: 'viewingMonitoringListsPromoRegistry', // это бэк будет присылать данные в таблицу ток промо
  // * Экспорт списка на мониторинг
  exportMonitoringList: 'exportMonitoringList',
  // * Создание и копирование списка на мониторинг
  createAndCopyMonitoringList: 'createAndCopyMonitoringList',
  // * Удаление списка на мониторинг
  deleteMonitoringList: 'deleteMonitoringList',
  // * Настройка полей шаблона списка на мониторинг
  configureMonitoringListTemplateFields: 'configureMonitoringListTemplateFields', // Удаляем, так как раздел в настройках выпиливаем
  // * Изменение списка на мониторинг
  changeMonitoringList: 'changeMonitoringList',
  // * Рекомендация к изменению списка на мониторинг
  recommendationToChangeMonitoringList: 'recommendationToChangeMonitoringList',

  // * Рекомендация к изменению списка на мониторинг с выбором согласующего
  recommendationToChangeMonitoringListWithUserChoice: 'recommendationToChangeMonitoringListWithUserChoice',

  // * Согласование списка на мониторинг
  approveMonitoringList: 'approveMonitoringList',
  // * Согласование рекомендации к изменению списка на мониторинг
  approveRecommendationToChangeMonitoringList: 'approveRecommendationToChangeMonitoringList', // TODO. Будет для роли ДУКА новая кнопка потом
  // * Отправка рекомендаций к изменению списка на согласование // Удалить колонку
  sendRecommendationToChangeMonitoringList: 'sendRecommendationToChangeMonitoringList', // дубль recommendationToChangeMonitoringList

  // ! Реестр задач на мониторинг

  // * Просмотр реестра задач на мониторинг
  viewMonitoringTasksList: 'viewMonitoringTasksList',
  // * Запуск/перезапуск задачи на мониторинг
  startRestartMonitoringTask: 'startRestartMonitoringTask',
  // * Остановка задачи на мониторинг
  stopMonitoringTask: 'stopMonitoringTask',
  // * Уведомление подрядчиков (выбранных и всех)
  sendNotificationContractors: 'sendNotificationContractors',

  // ! Работа с результатами мониторинга

  // * Просмотр результатов всех видов мониторингов цен
  viewMonitoringResultsAllTypesPrice: 'viewMonitoringResultsAllTypesPrice',
  // * Просмотр результатов сплошного (TOTAL CHECK) мониторинга цен
  viewMonitoringResultsTotalPrice: 'viewMonitoringResultsTotalPrice', // TODO Пока что не используется. Добавить потом согласовав с Андреем З
  // * Изменение товара в результатах сплошного (TOTAL CHECK) мониторинга цен
  changeMonitoringResultsTotalProduct: 'changeMonitoringResultsTotalProduct', // TODO Пока что не используется. Добавить потом согласовав с Андреем З
  // * Управление комментариями всех ролей к результатам мониторинга
  manageMonitoringResultsAllRolesComments: 'manageMonitoringResultsAllRolesComments',
  // * Управление своими комментариями к результатам мониторинга
  manageMonitoringResultsYourComments: 'manageMonitoringResultsYourComments',
  // * Внесение изменений в результаты мониторинга цен
  changeMonitoringResultsPrice: 'changeMonitoringResultsPrice',
  // * Экспорт результатов мониторинга
  exportMonitoringResults: 'exportMonitoringResults',
  // * Сохранить и отметить верным результат мониторинга
  markCorrectMonitoringResults: 'markCorrectMonitoringResults',

  // ! Внешние товары

  // * Просмотр справочника внешних товаров
  viewExternalProductsDirectory: 'viewExternalProductsDirectory',
  // * Редактирование справочника внешних товаров
  editExternalProductsDirectory: 'editExternalProductsDirectory',

  // ! Квоты

  // * Просмотр квот (в тч экспорт)
  viewQuotas: 'viewQuotas',
  // * Редактирование квот (в тч удаление, копирование, создание)
  editQuotas: 'editQuotas',

  // * Настройка параметров мониторингов
  configureMonitoringParameters: 'configureMonitoringParameters',

  // ! Список задач на мониторинг цен конкурентов (подрядчик)

  // * Выгрузка списков товаров/конкурентов для мониторинга
  uploadMonitoringProductOrCompetitorLists: 'uploadMonitoringProductOrCompetitorLists',
  // * Загрузка результатов мониторинга
  downloadMonitoringResults: 'downloadMonitoringResults',

  // ! Работа с задачами

  // * Переназначение задач внутри других ролей
  reassignOtherRolesTasks: 'reassignOtherRolesTasks',
  // * Просмотр задач своей роли
  viewYourRolesTasks: 'viewYourRolesTasks',
  // * Просмотр всех задач
  viewAllTasks: 'viewAllTasks',

  // ! Администрирование

  // * Управление пользователями, ролями и разрешениями
  manageUsersRolesAndPermissions: 'manageUsersRolesAndPermissions',
  // * Управление параметрами приложения
  manageApplicationsSettings: 'manageApplicationsSettings'
} as const

export const ROLE = {
  serviceAccount: 'service_account',
  administrator: 'administrator',
  priceAnalyticsSpecialist: 'price_analytics_specialist',
  contractor: 'contractor',
  pricingSpecialist: 'pricing_specialist',
  categoryManager: 'category_manager',
  promoPlanningSpecialist: 'promo_planning_specialist',
  commercialServiceDirector: 'commercial_service_director',
  commercialServiceSpecialist: 'commercial_service_specialist'
} as const

export const POSITION: Record<Role, string> = {
  service_account: 'Администратор',
  administrator: 'Администратор',
  price_analytics_specialist: 'Аналитик цен',
  contractor: 'Подрядчик',
  pricing_specialist: 'Специалист по ЦО',
  category_manager: 'Специалист по ОРКМ',
  promo_planning_specialist: 'Специалист по промо планированию',
  commercial_service_director: 'Директор по управлению категориями (ДУК)',
  commercial_service_specialist: 'Специалист/менеджер по УК'
} as const
